import React, { useContext } from "react";
import { Delete as DeleteIcon } from "@mui/icons-material";

import { getHotkeyLabel, useHotkeys } from "fond/hooks/useHotkeys";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarButton from "./ToolbarButton";
import { useHasEditableSelection } from "./useHasEditableSelection";

const DeleteButton: React.FC<IButtonProps> = ({ icon, title = "Delete feature(s)", ...rest }) => {
  const { drawControl } = useContext(MapContext);
  const hasEditableSelection = useHasEditableSelection();

  const handleOnClick = () => {
    drawControl.current?.trash();
  };

  useHotkeys({
    action: "DELETE",
    callback: (event) => {
      event.preventDefault();
      handleOnClick();
    },
    enabled: hasEditableSelection,
  });

  const tooltipTitle = `${title} (${getHotkeyLabel("DELETE")})`;

  return (
    <ToolbarButton
      title={title}
      {...rest}
      tooltip={tooltipTitle}
      onClick={handleOnClick}
      disabled={!hasEditableSelection}
      data-testid="toolbar-delete-button"
    >
      {icon || <DeleteIcon />}
    </ToolbarButton>
  );
};

export default DeleteButton;
